module.exports = __webpack_public_path__ + "media/incoming_call_ring.2eec32c7.mp3";